export default "/images/ee2a816a642b40b56446c06c7578f943.png";